import { Card, CardBody, Radio, RadioGroup } from '@heroui/react';
import { useState } from 'react';
import _ from 'lodash';

export function RadioBtn({ answerHistory, data, sendAnswer }) {
  const [answer, setAnswer] = useState(_.toString(answerHistory));

  const handleInputChange = (key) => {
    setAnswer(key);
    sendAnswer(_.parseInt(key));
  };

  return (
    <Card isBlurred shadow="sm">
      <CardBody>
        <RadioGroup value={answer} onValueChange={handleInputChange}>
          {data.map((item) => (
            <Radio className="p-4" key={item.text} value={item.key}>
              {item.text}
            </Radio>
          ))}
        </RadioGroup>
      </CardBody>
    </Card>
  );
}
